import { FC } from 'react';

import { CoOwner } from 'types';
import ShareEncumbranceViewCoOwnersTableHeader from './ShareEncumbranceViewCoOwnersTableHeader';
import ShareEncumbranceViewCoOwnersTableBody from './ShareEncumbranceViewCoOwnersTableBody';

type Props = {
  mainCoOwner: CoOwner;
  coOwnersList: CoOwner[];
  handleRemoveCoOwner: (index: number) => void; // eslint-disable-line
};

const ShareEncumbranceViewCoOwnersTable: FC<Props> = ({
  mainCoOwner,
  coOwnersList,
  handleRemoveCoOwner,
}) => (
  <div className="card card-bordered mt-4">
    <table className="table">
      <ShareEncumbranceViewCoOwnersTableHeader />
      <ShareEncumbranceViewCoOwnersTableBody
        mainCoOwner={mainCoOwner}
        coOwnersList={coOwnersList}
        handleRemoveCoOwner={handleRemoveCoOwner}
      />
    </table>
  </div>
);

export default ShareEncumbranceViewCoOwnersTable;
